import { ethers } from 'ethers';

export const isNull = (address: string) => ethers.constants.AddressZero === address;
